export const storageBaseUrl =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_LOCAL_STORAGE_URL
    : process.env.REACT_APP_PRODUCTION_STORAGE_URL;
export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_LOCAL_URL
    : process.env.REACT_APP_PRODUCTION_URL;
